<style scoped>
    .content-wrapper .content{
    padding-top: 95px;
}

.el-checkbox-group{
    padding: 10px;
}

.el-checkbox-button{
    margin: 5px;
    border: 1px solid #d8dce5;
    border-radius: 0.5px;
}

.el-checkbox-button .is-disabled .is-checked{
    border: 1px solid red;
}
.el-checkbox-button.is-disabled .el-checkbox-button__inner{
    color: #83878f;
}

</style>
<template>
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="content-wrapper">
    <section class="content">
        <div class="box">
        <div class="box-header with-border">
            <h3 class="box-title">DFP Setup for {{networkName}}</h3>
        </div>
        <div class="box-body" v-loading="loading">
            <el-button @click="createAdvAndPlacement()" :title="(hbAdvCreated) ? 'advertiser and placement already created' : 'create advertiser and placement'" :disabled="hbAdvCreated" type="primary">
            Create advertiser, placement and mod key with values <i v-if="creatingAdvertiser" class="el-icon-loading"></i>
            </el-button>

            <form method="post" v-on:submit.prevent="" class="form">
            <!-- <h5>Select domain</h5>
                        <p>Choose domain from the dropdown or create one by clicking + Create domain</p>
                        <div class="row">
                            <div class="col-md-9">
                                <el-select v-model="domId" placeholder="Select" @change="setDomUid()">
                                    <el-option v-for="domain in domains" :data-id="domain.uuid" :key="domain.name" :label="domain.name" :value="domain.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-3">
                                <router-link to="/admin/create-domain/" class="el-button el-button--info pull-right">
                                    <i class="el-icon-plus el-icon-left"></i>
                                    Create Domain
                                </router-link>
                            </div>
                        </div> -->
            <!-- <hr> -->
            <div class="box-body">
                <!-- <h5>Enter Advertiser's Name</h5> -->
                <!-- <p :class="{ 'control': true }"> -->
                <!-- <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="advertiser_name" type="text" placeholder="Enter Advertiser's Name" v-model="dfp.advertiser_name"></el-input> -->
                <!-- <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span> -->
                <!-- <hr> -->
                <!-- <h5>Enter number of creatives to be created</h5>
                            <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="number_of_creatives" type="number" placeholder="Enter number of creatives" v-model.number="dfp.number_of_creatives"></el-input>
                            <hr> -->
                <!-- <h5>Enter Order name prefix</h5>
                            <el-input class="" v-validate="'required'" data-vv-delay="1000" name="order_name_prefix" type="text" placeholder="Order name prefix" v-model="dfp.order_name_prefix"></el-input>
                            <hr> -->
                <!-- <h5>Enter prebid bucket range Min (in USD)</h5>
                            <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="prebid_bucket_range_min" type="number" step="0.01" placeholder="Min" v-model.number="dfp.prebid_bucket_range_min"></el-input>
                            <hr> -->
                <!-- <h5>Enter prebid bucket range Max (in USD)</h5>
                            <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="prebid_bucket_range_max" type="number" step="0.01" placeholder="Max" v-model.number="dfp.prebid_bucket_range_max"></el-input>
                            <hr> -->
                <!-- <h5>Enter prebid bucket Granularity (in USD)</h5>
                            <el-input class = "" v-validate="'required'" data-vv-delay="1000" name="granularity" type="number" step="0.01" placeholder="Granularity" v-model.number="dfp.granularity"></el-input>
                            <hr> -->
                <h5>Select Bidders</h5>
                <!-- <div class="btn-label-container" :content="dfp.biddersList" @change="biddersListChange">
                                <button class="btn-label" v-for="bidder in bidders" :key="bidder.id" :title="(current_active_bidders.indexOf(bidder.id) > -1) ? 'Cannot be removed' : 'select bidder'"  :disabled="current_active_bidders.indexOf(bidder.id) > -1">{{ bidder.name }} </button>
                            </div> -->
                <!-- <el-checkbox-group v-model="dfp.biddersList" @change="biddersListChange" :fill="'#d8dce5'">
                                <el-checkbox-button @change="initiateSetup(bidder)" v-for="bidder in bidders" :label="bidder.id" :key="bidder.id" :title="(current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1) ? 'DFP setup is already complete' : 'select bidder'"  :disabled="current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1">
                                    {{ bidder.name }} <i v-if="current_started_bidders.indexOf(bidder.id) > -1" class="el-icon-loading"></i>
                                </el-checkbox-button>
                            </el-checkbox-group> -->
                <el-row style="display: flex;flex-flow: row wrap;">
                <el-col :span="4" v-for="bidder in bidders" style="margin: 10px;">
                    <div style="text-align: left;position: relative;">
                    <el-button @click="initiateSetup(bidder)" :label="bidder.id" :key="bidder.id" :title="(current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1) ? 'DFP setup is already complete' : 'select bidder'" :disabled="!hbAdvCreated || (current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1)" type="primary">
                        {{ bidder.name }} <i v-if="current_started_bidders.indexOf(bidder.id) > -1" class="el-icon-loading"></i>
                    </el-button>
                    <i @click="retryLicas(bidder)" style="position: absolute;top: 50%;transform: translateY(-50%);margin-left: 5px;cursor: pointer;" title="retry failed line item create associations" class="el-icon-refresh"></i>
                    </div>
                </el-col>
                </el-row>
                <!-- <el-button @click="initiateSetup(bidder)" v-for="bidder in bidders" :label="bidder.id" :key="bidder.id" :title="(current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1) ? 'DFP setup is already complete' : 'select bidder'"  :disabled="current_active_bidders.indexOf(bidder.id) > -1 || current_started_bidders.indexOf(bidder.id) > -1" type="primary">
                                {{ bidder.name }} <i v-if="current_started_bidders.indexOf(bidder.id) > -1" class="el-icon-loading"></i>
                            </el-button> -->
                <h5>Select Currency</h5>
                <el-select v-model="dfp.prebid_currency" placeholder="Select" @change="currencyChanged" >
                <el-option v-for="option in currenciesOptions" :key="option.id" :label="option.code" :value="option.id">
                </el-option>
                </el-select>
                <hr>
                <el-button class="el-button el-button--info" @click="onSubmit()" :disabled="!isComplete || hbSetupInitiated" :title="hbSetupInitiated ? 'Header Bidding Setup is running' : ''">
                <i class="el-icon-plus el-icon-left"></i>
                Submit
                </el-button>
                <router-link to="/admin/dfp-settings/" class="el-button el-button--danger">
                Cancel
                </router-link>
            </div>
            <hr>
            </form>
        </div>
        </div>
    </section>
    </div>
</template>
<script>
import axios from 'axios';
// import EventBus from '../../../eventBus.js';
export default {
    data: () => {
    return {
        name: undefined,
        publishers: [],
        isSecure: true,
        pubDFP: false,
        domId: undefined,
        domUuId: undefined,
        networkName: undefined,
        hbSetupInitiated: false,
        hbAdvCreated: false,
        creatingAdvertiser: false,
        bidders: [],
        current_active_bidders: [],
        current_started_bidders: [],
        dfp: {
            id: undefined,
            // advertiser_name: '',
            number_of_creatives: 12,
            prebid_currency: '',
            prebid_bucket_range_min: 0.01,
            prebid_bucket_range_max: 20.00,
            granularity: 0.01,
            order_name_prefix: 'ATD ',
            biddersList: []
        },
        message: '',
        countryId: '',
        currencyId: '',
        countryOptions: [],
        currenciesOptions: [],
        loading: true
    }
    },
    created: function() {
    this.initialize();
    },
    methods: {
    initialize() {
        const self = this;
        console.log(this.$route.params.dfpId);
        this.dfp.id = this.$route.params.dfpId;
        axios.all([
            axios.get(BASE_URL + 'v1/domains/'),
            axios.get(BASE_URL + 'v1/currencies/'),
            axios.get(BASE_URL + 'v1/hb-config/dfp/' + this.dfp.id),
            axios.get(BASE_URL + 'v1/bidders/'),
            axios.get(BASE_URL + 'v1/network-name/' + this.dfp.id + '/')
        ])
        .then(axios.spread(function(domains, currencies, hbConfigs, bidders, networkdetail) {
            console.log(networkdetail);
            let dfp_currencies = [];
            self.domains = domains.data;
            self.currenciesOptions = currencies.data;
            self.populateDfpData(hbConfigs.data);
            self.bidders = bidders.data;
            self.networkName = networkdetail.data['0'].display_name;
            self.hbSetupInitiated = networkdetail.data['0'].hb_setup_initiated;
            self.hbAdvCreated = networkdetail.data['0'].advertiser_id != "0" && networkdetail.data['0'].dfp_hb_placement_id != "0";

            dfp_currencies.push(networkdetail.data['0'].currency_code);
            let seconday_currencies = networkdetail.data['0'].secondary_currency_codes.replace('[','').replace(']','').replaceAll("'",'').split(', ');
            dfp_currencies = dfp_currencies.concat(seconday_currencies);

            self.currenciesOptions = self.currenciesOptions.filter((currenciesOption) =>{
                return dfp_currencies.includes(currenciesOption.code);
            });

            console.log(self.currenciesOptions);
            self.loading = false;
        }))
        .catch(error => console.log(error))
    },
    biddersListChange() {
        console.log(this.dfp.biddersList);
    },
    setDomUid() {
        let i = 0;
        console.log(this.domUuId);
        for (; i < this.domains.length; i++)
        if (this.domains[i].id == this.domId) {
            this.domUuId = this.domains[i].uuid;
            break;
        }
        console.log(this.domUuId);
    },
    onSubmit() {
        let request_data = {
        "hb_config": {
            // "advertiser_name": this.dfp.advertiser_name,
            "number_of_creatives": this.dfp.number_of_creatives,
            "prebid_currency": this.dfp.prebid_currency,
            "order_name_prefix": this.dfp.order_name_prefix,
            "prebid_bucket_range_min": this.dfp.prebid_bucket_range_min,
            "prebid_bucket_range_max": this.dfp.prebid_bucket_range_max,
            "granularity": this.dfp.granularity,
            "dfp_network": this.$route.params.dfpId
        },
        "bidder": JSON.stringify(this.dfp.biddersList)
        }

        axios.post(BASE_URL + 'v1/hb-config/', request_data)
        .then(response => {
            this.$notify({
            title: 'Success',
            message: 'Successfully updated the dfp settings',
            type: 'success'
            });

            setTimeout(() => { this.$router.push('/admin/dfp-settings/'); }, 1000);
        })
        .catch(error => {
            this.$notify({
            title: 'Warning',
            message: 'Unable to update the dfp settings',
            type: 'warning'
            });
        })
    },
    submit() {
        console.log('Submitting DFP setup details');
        console.log(this.dfp);
    },
    initiateSetup(bidder) {
        console.log(bidder);
        let request_data = {
        is_amp: false
        };
        axios.post(BASE_URL + `v1/hb-dfp-add-bidder-setup/${this.dfp.id}/bidder/${bidder.id}`, request_data)
        .then(response => {
            this.$notify({
            title: 'Success',
            message: `Setup initialized for bidder - ${bidder.code}`,
            type: 'success'
            });
            // this.initialize();
            this.current_started_bidders.push(bidder.id);
        })
        .catch(error => {
            this.$notify({
            title: 'Warning',
            message: 'Server Issue',
            type: 'warning'
            });
        })
    },
    populateDfpData(dfpData) {
        console.log(dfpData);
        // this.dfp = dfpData[0].hb_config;   
        for (let i = 0; i < dfpData.length; i++) {
        this.dfp.biddersList.push(dfpData[i].bidder.id);
        if (dfpData[i].complete) this.current_active_bidders.push(dfpData[i].bidder.id);
        else if (dfpData[i].started) this.current_started_bidders.push(dfpData[i].bidder.id);
        }
        if (dfpData[0]) {
        // this.dfp.advertiser_name = dfpData[0].hb_config.advertiser_name;
        this.dfp.number_of_creatives = dfpData[0].hb_config.number_of_creatives;
        this.dfp.prebid_currency = dfpData[0].hb_config.prebid_currency;
        this.dfp.order_name_prefix = dfpData[0].hb_config.order_name_prefix;
        this.dfp.prebid_bucket_range_min = dfpData[0].hb_config.prebid_bucket_range_min;
        this.dfp.prebid_bucket_range_max = dfpData[0].hb_config.prebid_bucket_range_max;
        this.dfp.granularity = dfpData[0].hb_config.granularity;
        // this.dfp.dfp_credentials = this.$route.params.dfpId
        console.log(this.dfp);
        console.log(this.dfp.biddersList);
        }
    },
    createAdvAndPlacement() {
        console.log('createAdvAndPlacement')
        this.creatingAdvertiser = true;
        console.log(this.dfp.prebid_currency);
        let request_data = {
        is_amp: false
        };
        axios.post(BASE_URL + `v1/hb-dfp-adv-placement-setup/${this.dfp.id}`, request_data)
        .then(response => {
            console.log(response);
            this.$notify({
            title: 'Success',
            message: 'Advertiser and placement will be created',
            type: 'success'
            });
            setTimeout(() => {
            window.location.reload();
            }, 5000);
        })
    },
    currencyChanged() {

    },
    retryLicas(bidder) {
        if(!this.hbAdvCreated || !(this.current_active_bidders.indexOf(bidder.id) > -1 || this.current_started_bidders.indexOf(bidder.id) > -1)){
            this.$notify({
                title: 'warning',
                message: 'The advertiser needs to be created or line items for the bidder needs to be created first',
                type: 'warning'
            });
            return;
        }
        let request_data = {
        is_amp: false
        };
        axios.post(BASE_URL + `v1/hb-retry-failed-licas/${this.dfp.id}/bidder/${bidder.id}`, request_data)
        .then(response => {
            console.log(response)
        });
    }
    },
    // props: {
    //    disabled: Boolean,
    // },
    computed: {
    isComplete() {
        return this.dfp.prebid_currency;
    }
    }
};

</script>



// WEBPACK FOOTER //
// EditDfp.vue?1fe2dafc